import * as React from 'react';
import { Dashboard } from 'app/area/dashboard/dashboard';
import styles from './dashboard.scss';
import { RouterProps, withRouter } from 'app/components/enhancers/with-router';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Draft } from 'app/area/case/draft';

interface DashboardRouteProps {
  router: RouterProps;
  params: { favouriteId?: string; dashboardType?: string };
}

const CaseWithRouter = withRouter(Case);
const DraftWithRouter = withRouter(Draft);

export function DashboardRoute({
  router,
  params
}: DashboardRouteProps) {

  return (
    <div className={styles.dashboardView}>
      <Dashboard
        dashboardType={parseInt(params.dashboardType, 10)}
        requestedMainFavouriteId={parseInt(params.favouriteId, 10)}
        showDescription={true}
        location={router.location}
        editSavedFavourite={Boolean(router.location?.query?.editSavedFavourite)} />
        <Outlet context={{ favouriteId: Number(params.favouriteId), dashboardType: Number(params.dashboardType) }} />
    </div>
  );
}

export const DashboardCaseModalContainer = () => {
  const { favouriteId } = useOutletContext<{ favouriteId: number }>();
  const { dashboardType } = useOutletContext<{ dashboardType: number }>();
  return (
    <CaseViewModal favouriteId={favouriteId} dashboardType={dashboardType}>
      <Outlet />
    </CaseViewModal>
  );
};

export const DashboardCaseView = () => {
  return (
    <CaseWithRouter />    
  );
};

export const DashboardCaseDraft = () => {
  return (
    <DraftWithRouter />
  );
};
